import { createSlice } from "@reduxjs/toolkit";
const initialState =
{
  SplDisc:false,
  TDiscPercent: false,
  TDiscAmt: false,
  LDiscPercent: true,
  LDiscAmt: true,
  FOC: false, 
  Excise: false, 
  BaseRate: false, 
  Tax: true, 
  Rebate:false,
  Narration:false,
  Cess:false,
  AddCess:false
};
// TypeReduce CostDis%cDiscAmt
const GrnModelCheckboxSlice = createSlice({
  name: "grnModelCheckbox",
  initialState: { value: initialState },

  reducers: {
    SetGrnModelCheckbox: (state, action) => {
      state.value = action.payload;
    },

    ClearGrnModelCheckbox: (state) => {
      state.value = initialState;
    },
  },
});

export const { SetGrnModelCheckbox, ClearGrnModelCheckbox } = GrnModelCheckboxSlice.actions;
export default GrnModelCheckboxSlice.reducer;
